import React, { useRef } from 'react';
import {
  StyledMainProductPlaceholder,
  StyledOfferSection,
  StyledOfferTitle,
} from './style';
import { ProductMadnessSpecialOfferMainProduct as MainProduct } from '../Products/main';
import { Gradient, MainProductData } from 'utils/types';

interface IProductMadnessOfferSection {
  text: string;
  textColor: Gradient;
  fontSize: number;
  mainProduct: MainProductData | null;
  top: number;
  children: JSX.Element;
}

export const ProductMadnessOfferSection: React.FC<
  IProductMadnessOfferSection
> = ({ text, textColor, fontSize, mainProduct, top, children }) => {
  const refOfferSection = useRef<HTMLDivElement | null>(null);

  const right = refOfferSection?.current?.offsetWidth
    ? 22624 / Math.pow(refOfferSection.current.offsetWidth, 1.5)
    : 10;

  return (
    <StyledOfferSection ref={refOfferSection} right={right} top={top}>
      <StyledOfferTitle title={text} textColor={textColor} fontSize={fontSize}>
        {text}
      </StyledOfferTitle>
      {mainProduct ? (
        <MainProduct
          quantityDisplay={mainProduct.quantityDisplay}
          images={mainProduct.images}
        />
      ) : (
        <StyledMainProductPlaceholder />
      )}
      {children}
    </StyledOfferSection>
  );
};
